// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e7b8d3e","455":"04788393","879":"04acd453","977":"39135969"}[chunkId] + ".chunk.js";
};